class TopBack {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){    
    const topBackTrigger = document.querySelector(".js-top-back")

    topBackTrigger.addEventListener("click", () => {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    })
  }
}
